<template>
  <div>
    <p-no-product-content v-if="isNotSoldByCoop" data-test-no-product-info-block>
      <template #info>{{ i18n._('Aucune offre disponible') }}</template>
      <template #detail data-test-no-product-info-detail>
        {{ i18n._('Vous pouvez demander directement le prix à votre {tech}.', { tech: appTypeLocale.tech }) }}
      </template>
    </p-no-product-content>
    <p-no-product-content
      v-if="hasNoOffer"
      data-test-no-offer-info-block
      :is-front-agri="isFrontAgri"
      :product="product"
    >
      <template v-if="isFrontAgri" #info>
        {{ i18n._('Demander le prix à votre {tech}.', { tech: appTypeLocale.tech }) }}
      </template>
      <template v-if="isFrontAgri" #detail>
        {{
          i18n._(
            "Nous n'avons actuellement aucune offre active sur ce {productGenericLabel}. Votre {tech} peut vous renseigner.",
            { tech: appTypeLocale.tech, productGenericLabel },
          )
        }}
      </template>
    </p-no-product-content>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { getAppTypeLocale } from '@b2ag/locale'
import { currentAppBrand } from '@b2ag/app-brands'
import PNoProductContent from '../PNoProductContent/PNoProductContent.vue'
import type { Product } from './typings'
import { i18n } from '@b2ag/locale'

export default defineComponent({
  name: 'PUnprocessableProduct',
  components: { PNoProductContent },
  props: {
    product: {
      type: Object as PropType<Product>,
      default: () => ({}),
    },
    hasNoOffer: {
      type: Boolean,
      default: false,
    },
    isNotSoldByCoop: {
      type: Boolean,
      default: false,
    },
    productGenericLabel: {
      type: String,
      default: 'produit',
    },
    cooperativeName: {
      type: String,
      default: '',
    },
    isFrontAgri: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const appTypeLocale = getAppTypeLocale(currentAppBrand)

    return {
      appTypeLocale,
      i18n,
    }
  },
})
</script>
